import { render, staticRenderFns } from "./ShopeePromotions.vue?vue&type=template&id=b2adec42&"
import script from "./ShopeePromotions.vue?vue&type=script&lang=js&"
export * from "./ShopeePromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports